import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const moduleConfigsSelector = createSelector(rootSelector, state => state.moduleConfigs);
